export default __webpack_public_path__ + "static/media/instagram.43bd5f3c.svg";